import { createContext, useCallback, useContext, useEffect, useState } from "react";
import bizApi from "@/lib/businessApi";

const BusinessAuthContext = createContext(null);

export function BusinessAuthProvider({ children }) {
  const [state, setState] = useState({ status: "loading", user: null, org: null });

  useEffect(() => {
    // pas de cookie indicateur → visiteur anonyme : on évite un 401 inutile en console
    if (typeof document !== "undefined" && !document.cookie.includes("miles_business_hint=")) {
      setState({ status: "out", user: null, org: null });
      return;
    }
    bizApi.get("/auth/me")
      .then((r) => setState({ status: "in", user: r.data.user, org: r.data.org }))
      .catch(() => setState({ status: "out", user: null, org: null }));
  }, []);

  const apply = (r) => setState({ status: "in", user: r.data.user, org: r.data.org });
  const login = useCallback(async (email, password) => apply(await bizApi.post("/auth/login", { email, password })), []);
  const signup = useCallback(async (payload) => apply(await bizApi.post("/auth/signup", payload)), []);
  const logout = useCallback(async () => {
    try { await bizApi.post("/auth/logout"); } catch { /* session déjà expirée */ }
    setState({ status: "out", user: null, org: null });
  }, []);
  const setOrg = useCallback((org) => setState((s) => ({ ...s, org })), []);

  return (
    <BusinessAuthContext.Provider value={{ ...state, login, signup, logout, setOrg }}>
      {children}
    </BusinessAuthContext.Provider>
  );
}

export const useBusinessAuth = () => useContext(BusinessAuthContext);
